module.exports = __webpack_public_path__ + "static/media/sm.83eb91da.svg";